import { render, staticRenderFns } from "./kr-reset-password.vue?vue&type=template&id=d70c51ec&"
import script from "./kr-reset-password.vue?vue&type=script&lang=js&"
export * from "./kr-reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports